import { Injectable } from '@angular/core';
import { FieldConfig } from './form.type';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  toFormGroup(fields: FieldConfig[] | undefined): FormGroup {
    if (fields == undefined) return new FormGroup({});
    const group: any = {};

    for(const field of fields){
      let value = field.value ?? '';
      if (field.disabled) {
        value = {value: field.value ?? '', disabled: true};
      }
      group[field.name] = field.validation ? new FormControl(value, field.validation) : new FormControl(value);
    }

    return new FormGroup(group);
  }
}
